
<script>
import { Line } from 'vue-chartjs'
export default {
extends: Line,
props:{
  columnaX:null,
  columnaY:null,
  nombrex:null
},
  data: () => {
    return {
        
    };
  },
  created() {
   //this.grafica();
  },
     mounted () {
      if (this.columnaX != null && this.columnaY != null && this.nombrex != null) {
        this.grafica();
      }
     },
methods: {
grafica(){
  this.renderChart(
      {
        labels: this.columnaX,
        datasets: this.columnaY
      },
      { responsive: true, maintainAspectRatio: false }
    );
    }
  },
};
</script>
<style scoped>
</style>